import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import styled from 'styled-components';

import { ProductDuration } from 'utils/services/VervAPI';
import { useT } from '@hooks';
import { appStore } from '@store';

interface Props {
	periodText?: string;
	introPeriodText?: string;
	fullPriceText?: string;
	introPriceText?: string;
	currency?: string;
	withRenewalText?: boolean;
	duration?: ProductDuration;
	fullPrice?: number;
	introPrice?: number;
}

const Container = styled.div`
	padding: 0 20px;
	font-weight: 300;
	font-size: 12px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.text1};
	text-align: left;

	& a {
		text-decoration: underline;
		color: ${({ theme }) => theme.colors.text7};
	}
`;

const Text = styled.div`
	margin-bottom: 16px;
`;

const Description = styled.div`
	color: #bcbcbc;
`;

export const Agreements: FC<Props> = observer(props => {
	const { withRenewalText = true, duration, fullPrice, introPrice } = props;
	const { T } = useT();
	const [periodText, setPeriodText] = useState('month');
	const [introPeriodText, setIntroPeriodText] = useState('month');
	const [fullPriceText, setFullPriceText] = useState('');
	const [introPriceText, setIntroPriceText] = useState('');
	const { product: paymentModal } = appStore.paymentStore;
	const [textValue, setTextValue] = useState(T('get_my_plan_warning_text'));

	useEffect(() => {
		if (paymentModal.details?.intro_amount) {
			setTextValue(T('get_my_plan_warning_text_v2'));
		} else {
			setTextValue(T('get_my_plan_warning_text'));
		}
	}, [paymentModal]);

	useEffect(() => {
		const durationToUse = duration ?? paymentModal.details?.duration;
		const trialPeriod = paymentModal.details?.trial_period_days || 0;

		if (durationToUse != null) {
			if (durationToUse.unit === 'month') {
				const periodTextMonth =
					(durationToUse.value ?? 0) > 1
						? durationToUse.value === 6
							? T('tariff_months_variable')
							: T('tariff_months')
						: T('tariff_month');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextMonth}`);
			} else {
				const periodTextWeek =
					(durationToUse.value ?? 0) > 1 ? T('tariff_weeks') : T('tariff_week');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextWeek}`);
			}
		}

		if (trialPeriod !== 0) {
			if (trialPeriod === 365) {
				setIntroPeriodText(`12 ${T('tariff_months_variable')}`);
			} else if (trialPeriod === 90) {
				setIntroPeriodText(`3 ${T('tariff_months_variable')}`);
			} else if (trialPeriod === 7) {
				setIntroPeriodText(`1 ${T('tariff_week')}`);
			} else {
				setIntroPeriodText(`1 ${T('tariff_month')}`);
			}
		}

		if (paymentModal.details?.amount) {
			setFullPriceText(`${props.currency ?? ''} ${fullPrice ?? paymentModal.details.amount}`);
		}
		if (paymentModal.details?.intro_amount) {
			setIntroPriceText(
				`${props.currency ?? ''}${introPrice ?? paymentModal.details.intro_amount}`,
			);
		}
	});
	return (
		<Container>
			<Text>
				<span>
					{T('new_subscritions_agreement')}{' '}
					<a href='https://verv.com/terms-conditions/' target='_blank' rel='noreferrer'>
						{T('terms_conditions')}
					</a>{' '}
					{T('new_subscritions_and')}{' '}
					<a href='https://verv.com/privacy-policy-main/' target='_blank' rel='noreferrer'>
						{T('privacy_policy')}.
					</a>
				</span>
			</Text>
			{withRenewalText &&
				(paymentModal.details?.trial_period_days ? (
					<Description
						dangerouslySetInnerHTML={{
							__html: textValue
								.replace(/__introPriceText__/g, props.introPriceText ?? introPriceText)
								.replace(/__introPeriod__/g, props.periodText ?? introPeriodText)
								.replace(/__period__/g, props.periodText ?? periodText)
								.replace(/__fullPriceText__/g, props.fullPriceText ?? fullPriceText),
						}}
					/>
				) : (
					<Description
						dangerouslySetInnerHTML={{
							__html: textValue
								.replace('__period__', props.periodText ?? periodText)
								.replace('__fullPriceText__', props.fullPriceText ?? fullPriceText),
						}}
					/>
				))}
		</Container>
	);
});
